// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import app from '@/js/common'

// Toast
import './components/Toast/index.css';
import Toast from './components/Toast/index.js';
Vue.use(Toast);
//设置页面标题title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
//图片点击放大效果
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$app = app;
Vue.prototype.$url = 'http://yxs.ayunlian.com/';

const  ADD_COUNT = 'ADD_COUNT';//常量代替事件类型，是的代码更清晰
const  REMOVE_COUNT = 'REMOVE_COUNT';
// 注册状态管理全局参数
var store = new Vuex.Store({
  state:{
    token:'',
  },
  mutations:{
    [ADD_COUNT] (state , token,){
      state.token = localStorage.getItem('token');
    },
    [REMOVE_COUNT] (state, token){
      state.token = localStorage.removeItem('token');
    },
  }
});

router.beforeEach((to,from,next) =>{
  store.state.token = localStorage.getItem('token');
  if (to.meta.requireAuth) { //判断该路由是否需要登录权限
    if( store.state.token == 'undefined' || store.state.token == '' ){
      next({
        path: '/login',
        query: {redirect: to.fullPath}
        //将跳转的路由path作为参数，登录成功后跳转到该页面
      });
    }
    if (store.state.token !== '') { //通过vuex state 获取当前的token 是否存储
      next();
    }
    if( store.state.token == null ) {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
        //将跳转的路由path作为参数，登录成功后跳转到该页面

      });
    }
  }else{
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js